module.exports = __webpack_public_path__ + "static/img_4834-5912f2859949da89bb8fed608b721527.webp";